import React from 'react';
import Spinner from '../../components/Controls/Spinner';
import { Button } from 'reactstrap';

const FormSubmitButton = ({ text, isSubmitting }) => {
    return <Button
        color="primary"
        disabled={isSubmitting}
    >
        {text} 
        {isSubmitting && <Spinner className="ml-2" />}
    </Button>
}

export default FormSubmitButton;